import React from 'react';
import HomeContent from '../components/HomeContent/HomeContent';
import MotionContainer from '../components/Motion/MotionContainer';
import Section from '../components/Section/Section';

const Home = () => {
  return (
    <MotionContainer>
      <Section title="Home">
        <HomeContent />
      </Section>
    </MotionContainer>
  );
};

export default Home;
